import { render, staticRenderFns } from "./WolihubVendas.vue?vue&type=template&id=0f1752b6&scoped=true"
import script from "./WolihubVendas.vue?vue&type=script&lang=js"
export * from "./WolihubVendas.vue?vue&type=script&lang=js"
import style0 from "./WolihubVendas.vue?vue&type=style&index=0&id=0f1752b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1752b6",
  null
  
)

export default component.exports